"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UntaggedContainerQuery = exports.TaggedContainerQuery = exports.ContainerUpdate = exports.ContainerCreate = exports.ContainerTransport = exports.UntaggedContainerUpdate = exports.UntaggedContainerCreate = exports.UntaggedContainerTransport = exports.TaggedContainerUpdate = exports.TaggedContainerCreate = exports.TaggedContainerTransport = exports.ContainerStatusLabels = exports.ContainerStatus = exports.ContainerStatuses = exports.InventoryRecordType = exports.InventoryRecordTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const activity_record_transport_1 = require("../activity-record-transport");
const container_type_1 = require("./container-type");
// ----- Base Container Transport (Not Exported) -----
exports.InventoryRecordTypes = ['tagged', 'untagged'];
exports.InventoryRecordType = typebox_1.Type.Union(exports.InventoryRecordTypes.map((type) => typebox_1.Type.Literal(type)));
const ContainerTransportBase = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    // inventoryRecordType: InventoryRecordType, <-- removed trying to fix discriminator
    containerType: container_type_1.ContainerTypeTransport,
    activeAssignmentID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    metadata: common_1.MetaData,
});
const ContainerCreateBase = typebox_1.Type.Object({
    containerType: typebox_1.Type.String({ format: 'uuid' }),
    inventoryRecordType: exports.InventoryRecordType,
});
const ContainerUpdateBase = typebox_1.Type.Partial(typebox_1.Type.Omit(ContainerCreateBase, ['containerType']));
exports.ContainerStatuses = ['ACTIVE', 'OUT_OF_SERVICE', 'DECOMMISSIONED'];
exports.ContainerStatus = typebox_1.Type.Union(exports.ContainerStatuses.map((type) => typebox_1.Type.Literal(type)));
exports.ContainerStatusLabels = {
    ACTIVE: 'Active',
    OUT_OF_SERVICE: 'Out of Service',
    DECOMMISSIONED: 'Decommissioned',
};
// ----- Tagged Container Transport -----
exports.TaggedContainerTransport = typebox_1.Type.Composite([
    ContainerTransportBase,
    typebox_1.Type.Object({
        haulerID: typebox_1.Type.String({ format: 'uuid' }),
        status: exports.ContainerStatus,
        inventoryRecordType: typebox_1.Type.Literal('tagged'),
        lastActivity: typebox_1.Type.Optional(activity_record_transport_1.EquipmentActivityRecordTransport),
        name: typebox_1.Type.String(),
        decal: typebox_1.Type.Optional(typebox_1.Type.String()),
        notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    }),
]);
exports.TaggedContainerCreate = typebox_1.Type.Object({
    name: typebox_1.Type.String(),
    inventoryRecordType: typebox_1.Type.Literal('tagged'),
    decal: typebox_1.Type.Optional(typebox_1.Type.String()),
    decrementUntaggedInventory: typebox_1.Type.Boolean(),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.TaggedContainerUpdate = typebox_1.Type.Composite([
    typebox_1.Type.Partial(typebox_1.Type.Omit(exports.TaggedContainerCreate, ['decrementUntaggedInventory'])),
    typebox_1.Type.Object({
        containerType: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
// ----- Untagged Container Transport -----
exports.UntaggedContainerTransport = typebox_1.Type.Composite([
    ContainerTransportBase,
    typebox_1.Type.Object({
        inventoryRecordType: typebox_1.Type.Literal('untagged'),
        totalInventory: typebox_1.Type.Integer({ minimum: 0 }),
    }),
]);
exports.UntaggedContainerCreate = typebox_1.Type.Object({
    totalInventory: typebox_1.Type.Integer({ minimum: 0 }),
    inventoryRecordType: typebox_1.Type.Literal('untagged'),
});
exports.UntaggedContainerUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.UntaggedContainerCreate, []));
// Combined Container Transport
exports.ContainerTransport = typebox_1.Type.Union([exports.TaggedContainerTransport, exports.UntaggedContainerTransport]);
exports.ContainerCreate = typebox_1.Type.Intersect([
    ContainerCreateBase,
    typebox_1.Type.Union([exports.TaggedContainerCreate, exports.UntaggedContainerCreate]),
]);
exports.ContainerUpdate = typebox_1.Type.Intersect([
    ContainerUpdateBase,
    typebox_1.Type.Union([exports.TaggedContainerUpdate, exports.UntaggedContainerUpdate]),
]);
exports.TaggedContainerQuery = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        containerType: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        containerStyle: typebox_1.Type.Optional(container_type_1.ContainerType),
        decommissioned: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
]);
exports.UntaggedContainerQuery = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({ containerType: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })) }),
]);
//# sourceMappingURL=container.js.map